<div class="table-wrapper">
  <div class="global-cashflow-table">
    <div class="metadata-row">
      <div class="header-row-cell metadata-row-cell"><strong>Statement Date</strong></div>
      @if (headersMetadata?.length > 0) {
        @for (column of headersMetadata; track column) {
          <div class="metadata-row-cell row-value-cell">
            <strong>{{column?.statementDate}}</strong>
          </div>
        }
      }
    </div>
    <div class="metadata-row">
      <div class="header-row-cell metadata-row-cell"><strong>Scenario</strong></div>
      @if (headersMetadata?.length > 0) {
        @for (column of headersMetadata; track column) {
          <div class="metadata-row-cell row-value-cell">
            <strong>{{ column?.scenario !== '' ? column.scenario : 'HISTORICAL'}}</strong>
          </div>
        }
      }
    </div>
    <div class="metadata-row">
      <div class="header-row-cell metadata-row-cell"><strong>Months Covered</strong></div>
      @if (headersMetadata?.length > 0) {
        @for (column of headersMetadata; track column) {
          <div class="metadata-row-cell row-value-cell">
            <strong>{{column?.monthsInInterval}}</strong>
          </div>
        }
      }
    </div>
    <div class="metadata-row">
      <div class="header-row-cell metadata-row-cell"><strong>Prep Type</strong></div>
      @if (headersMetadata?.length > 0) {
        @for (column of headersMetadata; track column) {
          <div class="metadata-row-cell row-value-cell">
            <strong>{{column?.preparationType}}</strong>
          </div>
        }
      }
    </div>
    <div class="metadata-row">
      <div class="header-row-cell metadata-row-cell"><strong>Statement Type</strong></div>
      @if (headersMetadata?.length > 0) {
        @for (column of headersMetadata; track column) {
          <div class="metadata-row-cell row-value-cell">
            <strong>{{column?.interval}}</strong>
          </div>
        }
      }
    </div>

    @if (primaryEntity?.columns.length > 0) {
      @for (parentTemplateItem of templateItems; track parentTemplateItem; let parentTemplateIdx = $index) {
        <div class="body-row">
          <div class="header-row-cell">
            <strong><span>{{parentTemplateItem?.label}}</span></strong>
          </div>
        </div>
        @if (parentTemplateItem.children.length > 0) {
          @if (isSectionForEntitySpecificItems(parentTemplateItem)) {
            <div class="body-row">
              <div class="clickable header-row-cell" (click)="toggleEntityDisplay(parentTemplateIdx, 0)">
                @if (entityDrawerState[parentTemplateIdx][0]) {
                  <span>
                    <i class="fas fa-xs fa-chevron-down"></i>
                  </span>
                }
                @if (!entityDrawerState[parentTemplateIdx][0]) {
                  <span>
                    <i class="fas fa-xs fa-chevron-right"></i>
                  </span>
                }
                {{primaryEntity?.entityName}}
              </div>
              @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
                @if (templateItemAdditionalAttributes[childElement.standardLineItemId]?.isEntitySubsection) {
                  @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                    @if (!entityDrawerState[parentTemplateIdx][0]) {
                      <div app-debt-service-coverage-table-cell class="row-value-cell"
                        [hasScopes]="primaryEntityScopes.length > 0"
                        [rowIdx]="parentTemplateIdx"
                        [colIdx]="colIdx"
                        [childTemplateItemIdx]="childIdx"
                        [isPrimaryEntity]="isPrimarySelected"
                        [ref]="childElement.ref"
                        [equationValue]="analysisService.evaluateFormula(getEquationsForFormulaEvaluation(childElement, primaryEntity), primaryEntityScopes[colIdx])"
                        [scope]="primaryEntityScopes[colIdx]"
                        [textFormat]="childElement.textFormat"
                      ></div>
                    }
                  }
                }
              }
            </div>
            @if (entityDrawerState[parentTemplateIdx][0]) {
              @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
                @if (!specialRefsToNotShowForPrimaryEntity.includes(childElement.ref) && !templateItemAdditionalAttributes[childElement.standardLineItemId]?.isTemplateSection) {
                  @if (childElement.ref === 'REF_DSCR_USER_ENTERED_PROP_DEBT') {
                    @for (proposedDebt of proposedDebts; track proposedDebt) {
                      <div class="body-row">
                        <div class="header-row-cell child-element">{{proposedDebt.name}}</div>
                        @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                          <div app-debt-service-coverage-table-cell class="row-value-cell"
                            [hasScopes]="primaryEntityScopes.length > 0"
                            [rowIdx]="parentTemplateIdx"
                            [colIdx]="colIdx"
                            [allowEdit]="proposedDebtEditable"
                            [ref]="childElement.ref"
                            [equationValue]="equationValueForProposedDebt(proposedDebt, column.monthsInInterval)"
                            [textFormat]="childElement.textFormat"
                          ></div>
                        }
                      </div>
                    }
                  } @else {
                    @if (shouldShowRow(primaryEntity, childElement, parentTemplateItem)) {
                      <div class="body-row">
                        <div class="child-element header-row-cell">
                          {{childElement?.label}}
                        </div>
                        @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                          @if (templateItemAdditionalAttributes[childElement.standardLineItemId]?.isEntitySubsection) {
                            <div app-debt-service-coverage-table-cell class="row-value-cell"
                              [hasScopes]="primaryEntityScopes.length > 0"
                              [rowIdx]="parentTemplateIdx"
                              [colIdx]="colIdx"
                              [childTemplateItemIdx]="childIdx"
                              [isPrimaryEntity]="isPrimarySelected"
                              [ref]="childElement.ref"
                              [equationValue]="analysisService.evaluateFormula(getEquationsForFormulaEvaluation(childElement, primaryEntity), primaryEntityScopes[colIdx])"
                              [scope]="primaryEntityScopes[colIdx]"
                              [textFormat]="childElement.textFormat"
                            ></div>
                          } @else {
                            <div app-debt-service-coverage-table-cell class="row-value-cell"
                              [hasScopes]="primaryEntityScopes.length > 0"
                              [rowIdx]="parentTemplateIdx"
                              [colIdx]="colIdx"
                              [childTemplateItemIdx]="childIdx"
                              [isPrimaryEntity]="isPrimarySelected"
                              [ref]="childElement.ref"
                              [isEditing]="editingRow == parentTemplateIdx && editingColumn == colIdx  && editingChildTemplateItemIdx == childIdx && isEditingPrimaryEntity"
                              [equationValue]="analysisService.evaluateFormula(getEquationsForFormulaEvaluation(childElement, primaryEntity), primaryEntityScopes[colIdx])"
                              [originalValueBeforeOverrides]="getOriginalValueBeforeOverrides(childElement.ref, colIdx)"
                              [scope]="primaryEntityScopes[colIdx]"
                              [overrideValue]="displayDataOverrideValue(true, -1, childElement.ref, colIdx)"
                              [isHighlighted]="selectedRow == parentTemplateIdx && selectedColumn == colIdx  && selectedChildTemplateItemIdx == childIdx && isPrimarySelected"
                              [textFormat]="childElement.textFormat"
                              (highlightCell)="selectedCell(colIdx, parentTemplateIdx, childIdx, true, -1)"
                              (startedEditMode)="editCell(colIdx, parentTemplateIdx, childIdx, true, -1)"
                              (doneEditing)="doneEditingCell($event)"
                            ></div>
                          }
                        }
                      </div>
                    }
                  }
                }
              }
            }
            @if (linkedEntities.length > 0) {
              @for (linkedEntity of linkedEntities; track linkedEntity; let linkedEntityIdx = $index) {
                <div class="body-row">
                  <div class="clickable header-row-cell" (click)="toggleEntityDisplay(parentTemplateIdx, linkedEntityIdx+1)">
                    @if (!entityDrawerState[parentTemplateIdx][linkedEntityIdx+1]) {
                      <span>
                        <i class="fas fa-xs fa-chevron-right"></i>
                      </span>
                    }
                    @if (entityDrawerState[parentTemplateIdx][linkedEntityIdx+1]) {
                      <span>
                        <i class="fas fa-xs fa-chevron-down"></i>
                      </span>
                    }
                    {{linkedEntity?.entityName}}
                  </div>
                  @if (!entityDrawerState[parentTemplateIdx][linkedEntityIdx+1]) {
                    @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
                      @if (templateItemAdditionalAttributes[childElement.standardLineItemId]?.isEntitySubsection) {
                        @for (column of linkedEntity?.columns; track column; let colIdx = $index) {
                          <div app-debt-service-coverage-table-cell class="row-value-cell"
                            [hasScopes]="linkedEntityScopes[linkedEntityIdx].length > 0"
                            [rowIdx]="parentTemplateIdx"
                            [colIdx]="colIdx"
                            [childTemplateItemIdx]="childIdx"
                            [linkedEntityId]="linkedEntityIdx"
                            [ref]="childElement.ref"
                            [equationValue]="analysisService.evaluateFormula(getEquationsForFormulaEvaluation(childElement, linkedEntity), linkedEntityScopes[linkedEntityIdx][colIdx])"
                            [scope]="linkedEntityScopes[linkedEntityIdx][colIdx]"
                            [textFormat]="childElement.textFormat"
                          ></div>
                        }
                      }
                    }
                  }
                </div>
                @if (entityDrawerState[parentTemplateIdx][linkedEntityIdx+1]) {
                  @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
                    @if (!specialRefsToNotShowForLinkedEntities.includes(childElement.ref) && !templateItemAdditionalAttributes[childElement.standardLineItemId]?.isTemplateSection) {
                      @if (childElement.ref === 'REF_GCF_OPEN_TRADELINES') {
                        <div class="body-row">
                          @if (orderedEntitySeparatedOpenTradelines[linkedEntityIdx].length > 0) {
                            <div class="clickable tradeline-dropdown-cell" (click)="toggleTradelineDisplay(linkedEntityIdx)">
                              @if (!tradelineDrawerState[linkedEntityIdx]) {
                                <span>
                                  <i class="fas fa-xs fa-chevron-right"></i>
                                </span>
                              }
                              @if (tradelineDrawerState[linkedEntityIdx]) {
                                <span>
                                  <i class="fas fa-xs fa-chevron-down"></i>
                                </span>
                              }
                              {{childElement?.label}}
                            </div>
                          } @else {
                            <div class="child-element header-row-cell">{{childElement?.label}}</div>
                          }
                          @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                            @if (!tradelineDrawerState[linkedEntityIdx]) {
                              <div app-debt-service-coverage-table-cell class = "row-value-cell"
                                [hasScopes]="primaryEntityScopes.length > 0"
                                [rowIdx]="parentTemplateIdx"
                                [colIdx]="colIdx"
                                [allowEdit]="false"
                                [ref]="childElement.ref"
                                [equationValue]="linkedEntityScopes[linkedEntityIdx][colIdx][childElement.ref]"
                                [textFormat]="childElement.textFormat"
                                [displayNumForZero]="isTradelineSumANumber(orderedEntitySeparatedOpenTradelines[linkedEntityIdx])"
                              ></div>
                            }
                          }
                        </div>
                        @if (tradelineDrawerState[linkedEntityIdx]) {
                          @for (tradeline of orderedEntitySeparatedOpenTradelines[linkedEntityIdx]; track tradeline; let tradelineIdx = $index) {
                            <div class="body-row">
                              <div class="tradeline-header-row-cell">{{tradeline.displayName}}</div>
                              @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                                <div app-debt-service-coverage-table-cell class="row-value-cell"
                                  [hasScopes]="primaryEntityScopes.length > 0"
                                  [rowIdx]="parentTemplateIdx"
                                  [colIdx]="colIdx"
                                  [tradelineIdx]="tradelineIdx"
                                  [linkedEntityId]="linkedEntityIdx"
                                  [allowEdit]="true"
                                  [ref]="childElement.ref"
                                  [isEditing]="editingRow == parentTemplateIdx && editingColumn == colIdx  && editingChildTemplateItemIdx == childIdx && !isEditingPrimaryEntity && relatedEntityBeingEdited == linkedEntityIdx && tradelineBeingEdited == tradelineIdx"
                                  [equationValue]="equationValueForTradeline(tradeline, colIdx)"
                                  [originalValueBeforeOverrides]="equationValueForTradeline(tradeline, colIdx)"
                                  [overrideValue]="displayTradelineDataOverrideValue(linkedEntityIdx, tradelineIdx, colIdx)"
                                  [isHighlighted]="selectedRow == parentTemplateIdx && selectedColumn == colIdx  && selectedChildTemplateItemIdx == childIdx && !isPrimarySelected && linkedEntitySelected == linkedEntityIdx && tradelineSelected == tradelineIdx"
                                  [textFormat]="childElement.textFormat"
                                  [displayNumForZero]="equationValueForTradeline(tradeline) == 0"
                                  (highlightCell)="selectedCell(colIdx, parentTemplateIdx, childIdx, false, linkedEntityIdx, tradelineIdx)"
                                  (startedEditMode)="editCell(colIdx, parentTemplateIdx, childIdx, false, linkedEntityIdx, tradelineIdx)"
                                  (doneEditing)="doneEditingCell($event)"
                                ></div>
                              }
                            </div>
                          }
                          @if (orderedEntitySeparatedOpenTradelines[linkedEntityIdx].length > 0) {
                            <div class="body-row">
                              <div class="tradeline-header-row-cell">Total {{childElement?.label}}</div>
                              @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                                <div app-debt-service-coverage-table-cell class = "row-value-cell"
                                  [hasScopes]="primaryEntityScopes.length > 0"
                                  [rowIdx]="parentTemplateIdx"
                                  [colIdx]="colIdx"
                                  [allowEdit]="false"
                                  [ref]="childElement.ref"
                                  [equationValue]="linkedEntityScopes[linkedEntityIdx][colIdx][childElement.ref]"
                                  [textFormat]="childElement.textFormat"
                                  [displayNumForZero]="isTradelineSumANumber(orderedEntitySeparatedOpenTradelines[linkedEntityIdx])"
                                ></div>
                              }
                            </div>
                          }
                        }
                      } @else {
                        @if (shouldShowRow(linkedEntity, childElement, parentTemplateItem)) {
                          <div class="body-row">
                            <div class="child-element header-row-cell">{{childElement?.label}}</div>
                            @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                              @if (templateItemAdditionalAttributes[childElement.standardLineItemId]?.isEntitySubsection) {
                                <div app-debt-service-coverage-table-cell class = "row-value-cell"
                                  [hasScopes]="linkedEntityScopes[linkedEntityIdx].length > 0"
                                  [rowIdx]="parentTemplateIdx"
                                  [colIdx]="colIdx"
                                  [childTemplateItemIdx]="childIdx"
                                  [linkedEntityId]="linkedEntityIdx"
                                  [ref]="childElement.ref"
                                  [equationValue]="analysisService.evaluateFormula(getEquationsForFormulaEvaluation(childElement, linkedEntity), linkedEntityScopes[linkedEntityIdx][colIdx])"
                                  [scope]="linkedEntityScopes[linkedEntityIdx][colIdx]"
                                  [textFormat]="childElement.textFormat"
                                ></div>
                              } @else {
                                <div app-debt-service-coverage-table-cell class = "row-value-cell"
                                  [hasScopes]="linkedEntityScopes[linkedEntityIdx].length > 0"
                                  [rowIdx]="parentTemplateIdx"
                                  [colIdx]="colIdx"
                                  [childTemplateItemIdx]="childIdx"
                                  [linkedEntityId]="linkedEntityIdx"
                                  [ref]="childElement.ref"
                                  [isEditing]="editingRow == parentTemplateIdx && editingColumn == colIdx  && editingChildTemplateItemIdx == childIdx && !isEditingPrimaryEntity && relatedEntityBeingEdited == linkedEntityIdx"
                                  [equationValue]="analysisService.evaluateFormula(getEquationsForFormulaEvaluation(childElement, linkedEntity), linkedEntityScopes[linkedEntityIdx][colIdx])"
                                  [originalValueBeforeOverrides]="getOriginalValueBeforeOverrides(childElement.ref, colIdx, linkedEntityIdx)"
                                  [scope]="linkedEntityScopes[linkedEntityIdx][colIdx]"
                                  [overrideValue]="displayDataOverrideValue(false, linkedEntityIdx, childElement.ref, colIdx)"
                                  [isHighlighted]="selectedRow == parentTemplateIdx && selectedColumn == colIdx  && selectedChildTemplateItemIdx == childIdx && !isPrimarySelected && linkedEntitySelected == linkedEntityIdx"
                                  [textFormat]="childElement.textFormat"
                                  (highlightCell)="selectedCell(colIdx, parentTemplateIdx, childIdx, false, linkedEntityIdx)"
                                  (startedEditMode)="editCell(colIdx, parentTemplateIdx, childIdx, false, linkedEntityIdx)"
                                  (doneEditing)="doneEditingCell($event)"
                                ></div>
                              }
                            }
                          </div>
                        }
                      }
                    }
                  }
                }
              }
            }
            @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
              @if (templateItemAdditionalAttributes[childElement.standardLineItemId]?.isTemplateSection === true && allEntityScopes.length) {
                <div
                  class="body-row"
                  >
                  <div class="header-row-cell"><strong>{{childElement?.label}}</strong></div>
                  @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                    <div app-debt-service-coverage-table-cell class="row-value-cell"
                      [hasScopes]="allEntityScopes.length > 0"
                      [rowIdx]="parentTemplateIdx"
                      [colIdx]="colIdx"
                      [allowEdit]="proposedDebtEditable"
                      [ref]="childElement.ref"
                      [equationValue]="allEntityScopes[colIdx][childElement.ref] ? allEntityScopes[colIdx][childElement.ref] : 0"
                      [scope]="allEntityScopes[colIdx]"
                      [textFormat]="childElement.textFormat"
                    ></div>
                  }
                </div>
              }
            }
          } @else {
            @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
              @if (!specialRefsToNotShowForLinkedEntities.includes(childElement.ref) && !templateItemAdditionalAttributes[childElement.standardLineItemId]?.isTemplateSection) {
                <div class="body-row">
                  <div class="header-row-cell">{{childElement?.label}}</div>
                  @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                    <div app-debt-service-coverage-table-cell class="row-value-cell"
                      [hasScopes]="allEntityScopes.length > 0"
                      [rowIdx]="parentTemplateIdx"
                      [colIdx]="colIdx"
                      [allowEdit]="isGenericCalculation(childElement)"
                      [ref]="childElement.ref"
                      [equationValue]="analysisService.evaluateFormula(!!childElement.equationOverride ? childElement.equationOverride : childElement.originalEquation, allEntityScopes[colIdx])"
                      [scope]="allEntityScopes[colIdx]"
                      [textFormat]="childElement.textFormat"
                    ></div>
                  }
                </div>
              }
            }
            @for (childElement of parentTemplateItem.children; track childElement; let childIdx = $index) {
              @if (templateItemAdditionalAttributes[childElement.standardLineItemId]?.isTemplateSection === true && allEntityScopes.length) {
                <div
                  class="body-row"
                  >
                  <div class="header-row-cell"><strong>{{childElement?.label}}</strong></div>
                  @for (column of primaryEntity?.columns; track column; let colIdx = $index) {
                    <div app-debt-service-coverage-table-cell class="row-value-cell"
                      [hasScopes]="allEntityScopes.length > 0"
                      [rowIdx]="parentTemplateIdx"
                      [colIdx]="colIdx"
                      [allowEdit]="proposedDebtEditable"
                      [ref]="childElement.ref"
                      [equationValue]="allEntityScopes[colIdx][childElement.ref] ? allEntityScopes[colIdx][childElement.ref] : 0"
                      [scope]="allEntityScopes[colIdx]"
                      [textFormat]="childElement.textFormat"
                    ></div>
                  }
                </div>
              }
            }
          }
        }
      }
    }
  </div>
</div>